import { Box, Button, Card, List, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import DreamhomeReport from "../common/report/DreamhomeReport";
import Reports from "../reports/Report";
import UserReport from "../reports/UserReports";
import DateFilter from "../users/DateFilter";
// import { CreditLayoutTab } from "./creditsLayoutTab";
// import LegalStaffTab from "./legalStaffLayoutTab";

import "./style.css";
import { TicketsTab } from "./ticketsTab";
enum SpecialOffersTabsIds {
  Tickets = "tickets",
  Credits = "credits",
  Users = "users",
  Dreamhome="dreamhome"
}
const Tabs = [
  {
    title: "Weekly reports",
    id: SpecialOffersTabsIds.Credits,
  },
  // {
  //   title: "Users report",
  //   id: SpecialOffersTabsIds.Users
  // },
  // {
  //   title: "Dreamhome report",
  //   id: SpecialOffersTabsIds.Dreamhome
  // }
  // {
  //   title: "Tickets",
  //   id: SpecialOffersTabsIds.Tickets,
  // }
];
const SpecialOffersLayout = (props) => {
  const [currentTabId, setCurrentTabId] = useState<string>(
    SpecialOffersTabsIds.Credits
  );

  return (
    <Box className="specialOffersTabMainWrapper">
      <Box className="specialOffersTabsWrapper">
        <List>
          {Tabs.map((i, index) => {
            return (
              <Box
                marginBottom={(index + 1) * 5}
                onClick={() => setCurrentTabId(i.id)}
              >
                <p
                  className={`tabWrapper ${i.id === currentTabId ? "active" : ""
                    }`}
                >
                  <Typography>{i.title}</Typography>
                </p>
              </Box>
            );
          })}
        </List>
      </Box>
      <Box className="specialOffersTabContentWrapper">
        {currentTabId === SpecialOffersTabsIds.Credits && <Reports/>  }
        {/* {currentTabId === SpecialOffersTabsIds.Users &&  <UserReport/>} */}
        {/* {currentTabId === SpecialOffersTabsIds.Dreamhome && <DreamhomeReport/>} */}
      </Box>
    </Box>
  );
};
export default SpecialOffersLayout;
